import {loadTranslations, setLocale, syncTranslationWithStore} from 'react-redux-i18n';

import translations from '../translations';

function configureLanguages(store, defaultLanguage) {
	// Loop over the translations available and build a single object with locale as key
	let languageTokens = {};
	Object.keys(translations).forEach((language) => {
		languageTokens[translations[language].locale] = translations[language].tokens;
	});

	syncTranslationWithStore(store);
	store.dispatch(loadTranslations(languageTokens));
	store.dispatch(setLocale(defaultLanguage));
}

export default configureLanguages;


/** WEBPACK FOOTER **
 ** ./src/config/configureLanguages.js
 **/